export default __webpack_public_path__ + "static/media/tBTC-bridge-no-history-dark.8af1ca02.svg";